import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { startWith } from 'rxjs';
import { TimelineInterval } from '@aipb/gulliver/catalog/model';

export interface TimelineItem {
  label_from: string;
  label_to: string;
  value: number;
  value_in_percent: number;
}

export interface TimelineRange {
  start: number;
  end: number;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'cat-timeline-bar-chart',
  template: `
    <svg class="chart w-full" [attr.height]="itemsCount() * (itemHeight + 2)">
      @for (item of items(); track item.label_from; let i = $index) {
      <g [attr.transform]="'translate(0, ' + i * (itemHeight + 2) + ')'">
        <rect class="fill-gray-100" width="100%" [attr.height]="itemHeight"></rect>
        <rect class="bar" [attr.width]="item.value_in_percent + '%'" [attr.height]="itemHeight"></rect>
        @if (isInRange(i)) {
        <rect class="active" width="7" [attr.height]="itemHeight"></rect>
        }
        <text x="100%" dx="-.25em" dominant-baseline="middle" [attr.dy]="itemHeight / 2" class="value">
          {{ item.value }}
        </text>
        <text dominant-baseline="middle" class="label" dx="10" [attr.dy]="itemHeight / 2">
          {{ item.label_from | date : 'dd. MMMM yyyy' : '' : (activeLang$ | async) }}
          @if (intervalValue() !== 1 || intervalName() !== 'DAY') {
          <tspan class="fill-gray-500">
            +{{ intervalValue() }} {{ 'catalog.facet_timeline.intervals.' + intervalName() | transloco }}
          </tspan>
          }
        </text>
      </g>
      }
    </svg>
  `,
  styleUrls: ['./timeline-bar-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslocoModule]
})
export class TimelineFilterBarChartComponent {
  items = input<TimelineItem[]>([]);
  intervalValue = input.required<number>();
  intervalName = input.required<TimelineInterval>();

  itemsCount = computed(() => {
    const items = this.items();
    return items.length;
  });
  max = computed(() => {
    const items = this.items();

    return items.reduce((a, b) => Math.max(a, b.value), -Infinity);
  });
  range = input<TimelineRange>({
    start: null,
    end: null
  });
  itemHeight = 30;
  private transloco = inject(TranslocoService);
  activeLang$ = this.transloco.langChanges$.pipe(startWith(this.transloco.getActiveLang()));

  isInRange(index: number): boolean {
    const range = this.range();

    if (range.start == null || range.end == null) return false;

    return index >= range.start && index <= range.end;
  }
}
